import { theme } from 'theme'
import styled from 'particles/themes/styled'

interface InputFieldContainerProps {
    flexRow?: boolean
    maxWidth?: string
}
export const InputFieldContainer = styled.div<InputFieldContainerProps>`
    display: flex;
    flex-direction: column;
    max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : '755px')};
    width: '100%';
    .field-title {
        margin-bottom: ${theme.newSpacing.xxs};
        color: ${theme.newColors.neutral700};
    }
    .field-sub-title {
        max-width: 707px;
        margin-bottom: ${({ theme }) => theme.spacing[200]};
    }
    .field-bigger-title,
    .field-extra-bigger-title {
        font-size: ${theme.newFontSizes.m};
        font-weight: ${theme.fontWeight.medium};
        margin-bottom: ${theme.newSpacing.xxxxs};
    }
    .field-extra-bigger-title {
        margin-top: ${theme.newSpacing.l};
    }

    .bullet-list-field {
        display: flex;
        flex-direction: column;
        gap: ${theme.newSpacing.xxs};
        margin-bottom: ${theme.newSpacing.xxs};
    }
    .error {
        font-size: ${theme.newFontSizes.xs};
        color: ${theme.newColors.alertError200};
        margin-top: ${theme.newSpacing.xxs};
    }
    .sub-input-field {
        display: flex;
        gap: ${({ theme }) => theme.spacing[200]};
        &:before {
            content: '';
            width: 42px;
        }
    }
`
export const NumberInputRangeContainer = styled.div`
    .range-input {
        margin-top: ${theme.newSpacing.l};
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        height: fit-content;
        position: relative;
        .error {
            height: 100%;
            max-width: 193px;
        }
        .to-block {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 40px;
            align-self: center;
        }
        @media screen and (max-width: 768px) {
            width: fit-content;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: ${theme.newSpacing.s};
            .to-block {
                transform: translateX(0);
                left: 0;
                top: 0;
                position: relative;
            }
        }
    }
    .range-title {
        margin-bottom: ${theme.newSpacing.xxs};
    }
`
interface RequirementCardContainerProps {
    width?: string
    isCard?: boolean
}
export const RequirementCardContainer = styled.div<RequirementCardContainerProps>`
    width: ${({ width }) => (width ? width : '495px')};
    background-color: ${theme.newColors.neutral50};
    padding: ${({ isCard }) => (isCard ? theme.newSpacing.l : '0px')};
    box-shadow: ${({ isCard }) => (isCard ? '0px 0px 12px rgba(0, 0, 0, 0.06)' : 'none')};
    border-radius: 4px;
    margin: ${({ isCard }) => (isCard ? `${theme.newSpacing.m} 0` : '0px')};
    box-sizing: border-box;
    gap: ${({ theme }) => theme.spacing[600]};
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 768px) {
        padding: ${({ isCard }) => (isCard ? theme.newSpacing.s : '0px')};
        max-width: 100%;
        width: 100%;
    }
    .field-title,
    .field-sub-title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        svg {
            cursor: pointer;
        }
    }
    .field-title {
        margin-bottom: ${theme.newSpacing.xxxxs};
    }
    .field-sub-title {
        max-width: 700px;
        color: ${theme.newColors.neutral500};
        margin-bottom: ${({ theme }) => theme.spacing[200]};
    }
    .field-bigger-title {
        font-size: ${theme.newFontSizes.m};
        font-weight: ${theme.fontWeight.medium};
        margin-bottom: ${theme.newSpacing.xxxxs};
    }
    .field-close {
        justify-content: flex-end;
    }
    .field-notice {
        font-size: ${theme.newFontSizes.s};
        color: ${theme.newColors.neutral500};
        font-weight: ${theme.fontWeight.bold};
        margin-bottom: ${theme.newSpacing.l};
    }
    .adding-list-input-area {
        display: flex;
        flex-direction: column;
        margin-top: ${theme.newSpacing.l};
        gap: ${theme.newSpacing.xxs};
        .adding-list-input-title {
            font-size: ${theme.newFontSizes.s};
            font-weight: ${theme.fontWeight.medium};
        }
        .adding-list-input {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border: 1px solid ${theme.newColors.neutral200};
            padding-right: 3px;
            border-radius: 4px;
            .input-area {
                border: none !important;
                margin-bottom: 0;
            }
        }
        .error-border {
            border-color: ${theme.newColors.alertError200};
        }
    }
    .sub-label {
        margin-bottom: 8px;
    }
`
